/**
 * One-time `feature:sample_db_first_query` analytics — fires on the first
 * successful query execution against the sample connection (which is normally
 * the auto-executed showcase query). Persisted so it never re-fires.
 */
import { SAMPLE_DB_CONNECTION_ID } from '../sampleDatabaseConstants';

const STORAGE_KEY = 'jam-sql-sample-db-first-query-tracked';

export function maybeTrackSampleDbFirstQuery(connectionId: string | undefined): void {
  if (connectionId !== SAMPLE_DB_CONNECTION_ID) return;
  try {
    if (localStorage.getItem(STORAGE_KEY) === '1') return;
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // Storage unavailable — still fire; worst case is a duplicate event.
  }
  window.electronAPI?.analytics?.track('feature:sample_db_first_query')?.catch(() => {});
}
